<div *ngIf="isHealthcheck" style="background-color: #00C853; display: flex; align-items: center; justify-content: center; height: 100vh; width: 100vw; margin: 0;">
  <h1 style="color: white; font-family: sans-serif; font-size: 48px;">ok</h1>
</div>

<ng-container *ngIf="!isHealthcheck">
  <div class="main">
    <div class="form">
      <ng-container #formContainer></ng-container>
    </div>

    <div class="logo">
      <img decoding="async"
           fetchpriority="auto"
           loading="lazy"
           src="assets/images/logo.svg"
           alt="logo">
    </div>
  </div>

  <footer class="footer">
    <div class="powered-by">
      <div class="powered-by-text">
        {{ 'footer' | translate }}
      </div>
      <div class="powered-by-logo">
        <img ngSrc="assets/images/leafio.svg"
             width="95"
             height="26"
             alt="powered by leafio">
      </div>
    </div>
  </footer>

  <div *ngIf="forgotPassVisibility | async"
       class="remember-password"
       (click)="forgotPassVisibility.next(false)">
    <app-remember-password></app-remember-password>
  </div>
</ng-container>
